<ion-img
  [alt]="getImgAlt()"
  [src]="src"
  (ionImgDidLoad)="handleLoadFinished($event)"
  (ionError)="handleLoadFailed($event)"
  (ionImgWillLoad)="ionImgWillLoad.emit($event)"
></ion-img>
